module.exports = __webpack_public_path__ + "static/media/portaprent.3a29f232.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/logo/portaprent.svg
// module id = 87
// module chunks = 0